import styled, { css } from "styled-components";
import { AppointeddLogo, Divider } from "../common/components";
import { gap, marginTop, marginY, media, typography } from "../common/styles";
import React from "react";
import { useTranslation } from "react-i18next";
const urlParams = new URLSearchParams(window.location.search);
const inPopoverMode = !!urlParams.get("inPopoverMode");
const footerFixed = inPopoverMode ? css`
      position: sticky;
      bottom: 0;
      background-color: #ffffff;
    ` : null;
const Container = styled.footer`
  ${footerFixed}

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${marginTop.s}
  @media ${media.desktop} {
    ${marginTop.m}
  }
`;
const TextContainer = styled.div`
  display: flex;
  justify-content: center;

  ${gap.xs}

  @media ${media.desktop} {
    ${marginY.s}
  }
`;
const Text = styled.span`
  color: ${({
  theme
}) => theme.colours.dark};
  ${typography.appointedd}
`;
export function Footer() {
  const {
    t
  } = useTranslation();
  return <Container data-sentry-element="Container" data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      <Divider data-sentry-element="Divider" data-sentry-source-file="Footer.tsx" />
      <TextContainer data-sentry-element="TextContainer" data-sentry-source-file="Footer.tsx">
        <AppointeddLogo data-sentry-element="AppointeddLogo" data-sentry-source-file="Footer.tsx" />
        <Text data-sentry-element="Text" data-sentry-source-file="Footer.tsx">{t("footerText", {
          brandName: "Appointedd"
        })}</Text>
      </TextContainer>
    </Container>;
}
export default Footer;